(function ($) {
    'use strict';

    $(function () {
        var staticLogo = $('.static-logo-wrap');
        $('.title-area').hover(function () {
            staticLogo.toggleClass('static-logo-wrap--visible')
        });
    })
})(jQuery);